<template>
    <div class="card" style="min-height: 200px">
        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th>Bill Date</th>
                    <th>Bill NO</th>
                    <th class="text-right">Bill Amount</th>
                    <th class="text-center">VDS</th>
                    <th class="text-center">TDS</th>
                    <th class="text-center">Discount</th>
                    <th class="text-right">Already Paid</th>
                    <th class="text-right">Already Adjusted</th>
                    <th class="text-right">Due</th>
                    <th class="text-right">Payment</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(item, i) in payBills" :key="i">
                    <BillPayTableRow :item="item" />
                </template>
                <tr>
                    <td colspan="9" class="text-right"><h4>Total Payment</h4></td>
                    <td class="text-right">
                        {{total}}
                    </td>
                </tr>

                </tbody>
            </table>
            <!-- <p v-if="!purchase.length" class="text-center mt-5">No data</p> -->
        </div>
    </div>
</template>

<script setup>
import BillPayTableRow from '@/components/molecule/company/inventory/purchase/BillPayTableRow.vue'
    import { inject, computed } from 'vue'
    // const payBills = inject('payBills')
    const emits = defineEmits(['updateTotal']);
    const props = defineProps({
        payBills: Array,
    })

    const total = computed(() => {
        let sum = 0
         props.payBills.forEach(i => {
             sum+= i.payment !== '' ? parseFloat(i.payment) : 0
         })
        updateParentTotal(sum);
        return sum
    })

  const updateParentTotal = (totalAmount) => {
    emits('updateTotal', totalAmount);
  };
</script>
